(function () {
  function tick() {
    var hEl = document.getElementById('mqCountH');
    if (!hEl) return;
    var now = new Date();
    var end = new Date(now);
    end.setHours(23, 59, 59, 999);
    var s = Math.max(0, Math.floor((end - now) / 1000));
    var h = Math.floor(s / 3600);
    s -= h * 3600;
    var m = Math.floor(s / 60);
    s -= m * 60;
    hEl.textContent = String(h).padStart(2, '0');
    document.getElementById('mqCountM').textContent = String(m).padStart(2, '0');
    document.getElementById('mqCountS').textContent = String(s).padStart(2, '0');
  }
  tick();
  setInterval(tick, 1000);

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.rv:not(.in)').forEach(function (el) {
      io.observe(el);
    });
    document.querySelectorAll('.hero .rv, .trust .rv').forEach(function (el) {
      el.classList.add('in');
    });
  } else {
    document.querySelectorAll('.rv').forEach(function (el) {
      el.classList.add('in');
    });
  }
})();
